(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[615],{

/***/ 2115:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team",
      function () {
        return __webpack_require__(3613);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2036:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/iconmonstr-error-filled.c777f64d.svg","height":24,"width":24});

/***/ }),

/***/ 7553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BadgeList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7977);


function BadgeList(param) {
    let { list , onClick , customClass , activeItem , hideAll  } = param;
    const componentClass = "BadgeList ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const handleCategoryClick = (id)=>{
        onClick(id);
    };
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: componentClass,
        children: [
            (ref = !hideAll) !== null && ref !== void 0 ? ref : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "cursor-pointer ".concat(!activeItem ? "active" : ""),
                bg: "secondary",
                onClick: ()=>handleCategoryClick(""),
                children: "All"
            }),
            list && list.map((p)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "cursor-pointer ".concat(activeItem === p.slug ? "active" : ""),
                    bg: "secondary",
                    onClick: ()=>handleCategoryClick(p._id),
                    children: p.value
                }, p._id))
        ]
    });
}


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Team; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/assets/img/bg-about-global-team.webp
var bg_about_global_team = __webpack_require__(2472);
;// CONCATENATED MODULE: ./src/assets/img/team-hero.webp
/* harmony default export */ var team_hero = ({"src":"/_next/static/media/team-hero.60134e08.webp","height":803,"width":846,"blurDataURL":"data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAACwAQCdASoIAAgAAkA4JZACdADzes2gAP6yAb7YRD7ivYCzWWd58KXWQwO/341hmtX82Tejfn6X34cKdHjv9Vw++xRbsNBjU4ih89XFYxwyOVwKllxqHx1uAAA=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/assets/img/about-casper.webp
var about_casper = __webpack_require__(6162);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/modules/common/components/Founders/AboutFounders.tsx + 4 modules
var AboutFounders = __webpack_require__(2530);
// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/hero/Hero/Hero.tsx
var Hero = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/@shared/components/ui/BadgeList/BadgeList.tsx
var BadgeList = __webpack_require__(7553);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(8375);
// EXTERNAL MODULE: ./src/assets/icons/iconmonstr-error-filled.svg
var iconmonstr_error_filled = __webpack_require__(2036);
// EXTERNAL MODULE: ./src/modules/teams/components/TeamCard/TeamCard.tsx + 3 modules
var TeamCard = __webpack_require__(2771);
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
;// CONCATENATED MODULE: ./src/modules/teams/components/TeamList/TeamList.tsx






function TeamList(param) {
    let { list , categoryClass  } = param;
    var _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [
            list && list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    lg: 3,
                    className: "my-3 my-md-4 my-lg-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamCard/* default */.Z, {
                            item: {
                                categoryClass,
                                ...item
                            }
                        })
                    })
                }, (_id = item.id) !== null && _id !== void 0 ? _id : index)),
            !list || list.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                variant: "dark",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        customClass: "alert-exclamation mb-2",
                        source: iconmonstr_error_filled/* default.src */.Z.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "The content could not be loaded"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/modules/teams/hooks/useTeamList.ts
var useTeamList = __webpack_require__(4007);
;// CONCATENATED MODULE: ./src/pages/team.tsx













var __N_SSP = true;
function Team() {
    const { founders , executives , members , catList , category , handleBadgeListClick  } = (0,useTeamList/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: "Meet the Team Driving Enterprise Blockchain | Casper Labs",
                description: "Meet the dynamic Casper Labs team driving blockchain technology forward for enterprises. Discover the experts shaping the future of decentralized solutions.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: team_hero.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "teamsPage",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                customClass: "pt-0 pb-0 header heroTeam",
                                isHeader: true,
                                bgImage: team_hero.src,
                                col1: 6,
                                col2: 6,
                                halfTitle: "OUR TEAM",
                                title: 'Our Team of <span class="text-green">Experts</span>',
                                desc: "A truly global team, Casper Labs is dedicated to delivering impactful, innovative solutions that solve some of today's most pressing problems. We pride ourselves on our diverse backgrounds and experiences — and the unique blend of skills that they enable."
                            }),
                            founders && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutFounders/* default */.Z, {
                                        founders: founders.members
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        className: "pt-3 pt-xl-6 pb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "our-leadership position-relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "h1 mb-5 mb-lg-6",
                                                        children: "Our Leadership"
                                                    })
                                                }),
                                                executives && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamList, {
                                                    list: executives.members,
                                                    categoryClass: "bgTeam"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "our-team pt-6 pt-lg-7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(framerMotion/* default */.Z, {
                                                y: 400,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "h5",
                                                        children: "Our Team"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                        className: "my-5 align-items-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            md: 12,
                                                            className: "mb-4 mb-lg-0",
                                                            children: catList && catList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeList/* default */.Z, {
                                                                list: catList,
                                                                activeItem: category,
                                                                onClick: (item)=>handleBadgeListClick(item)
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            members && members.map((member, index)=>{
                                                var ref;
                                                var ref1;
                                                const show = (ref1 = category === ((ref = member.category.meta) === null || ref === void 0 ? void 0 : ref.slug)) !== null && ref1 !== void 0 ? ref1 : "";
                                                if (show) return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamList, {
                                                    list: member.members,
                                                    categoryClass: "bgTeam"
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                    customClass: "mt-5 pt-3 pb-0 globalTeam",
                                    colLg1: 6,
                                    colLg2: 6,
                                    title: "We are one global team",
                                    desc: "Our growing team of nearly 100 employees spans three continents and countless time zones. We’re committed to building the most reliable and sustainable blockchain for businesses by meeting organizations where they are, not vice versa.",
                                    linkButton: {
                                        label: "Join our team",
                                        link: "careers?section=jobs",
                                        variant: "primary"
                                    },
                                    bgImage: bg_about_global_team/* default.src */.Z.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                    customClass: "mt-0 pt-0 pb-0 aboutCasperLabs",
                                    colLg1: 6,
                                    colLg2: 6,
                                    title: "About <span class='text-red'>Casper Labs</span>",
                                    desc: "A growing number of organizations, from fast-growth companies to the public sector and Fortune 500 are choosing to build on Casper, thanks to its completely secure and future-proof architecture.",
                                    linkButton: {
                                        label: "About Us",
                                        link: "/company",
                                        variant: "secondary"
                                    },
                                    bgImage: about_casper/* default.src */.Z.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                col1: 5,
                                col2: 7,
                                title: "Sign up for our newsletter!"
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 8375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7150);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8146);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6792);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1068);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1485);
/* harmony import */ var _divWithClassName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9602);
/* harmony import */ var _createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6611);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);












const DivStyledAsH4 = (0,_divWithClassName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-heading', {
  Component: DivStyledAsH4
});
const AlertLink = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-link', {
  Component: _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
});
const defaultProps = {
  variant: 'primary',
  show: true,
  transition: _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
  closeLabel: 'Close alert'
};
const Alert = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((uncontrolledProps, ref) => {
  const {
    bsPrefix,
    show,
    closeLabel,
    closeVariant,
    className,
    children,
    variant,
    onClose,
    dismissible,
    transition,
    ...props
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(uncontrolledProps, {
    show: 'onClose'
  });
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'alert');
  const handleClose = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e => {
    if (onClose) {
      onClose(false, e);
    }
  });
  const Transition = transition === true ? _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z : transition;

  const alert = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    role: "alert",
    ...(!Transition ? props : undefined),
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
    children: [dismissible && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  });

  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Transition, {
    unmountOnExit: true,
    ...props,
    ref: undefined,
    in: show,
    children: alert
  });
});
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
}));

/***/ }),

/***/ 7977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,675,27,774,888,179], function() { return __webpack_exec__(2115); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);